import {observable} from 'mobx';
import {construct, ModelProperties} from 'utils';

export class LanguageLocaleKey {
    @observable id!: number;

    @observable name!: string;

    @observable enabled: boolean = true;

    constructor(key?: ModelProperties<LanguageLocaleKey>) {
        if (key) {
            construct(this, key);
        }
    }
}